let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aUa2T")).then(() => parcelRequire('bLwva'));